"use client";

import type { ReactNode } from "react";
import { usePathname, useRouter } from "@/lib/navigation";
import { SettingsLayout } from "@repo/ui";
import { useSession } from "@repo/api-client";
import { useMessages } from "@/locales";

export default function SettingsSectionLayout({
  children,
}: {
  children: ReactNode;
}) {
  const zhCN = useMessages();
  const { user } = useSession();
  const isClientAdmin = user?.clientOrgRole === "CLIENT_ADMIN";

  const router = useRouter();
  const pathname = usePathname();

  const navItems = [
    {
      id: "profile",
      label: zhCN.settings.profile,
      href: "/settings",
      active: pathname === "/settings",
      section: zhCN.settings.personal,
    },
    {
      id: "password",
      label: zhCN.settings.password,
      href: "/settings/password",
      active: pathname.startsWith("/settings/password"),
      section: zhCN.settings.personal,
    },
    {
      id: "security",
      label: zhCN.settings.security,
      href: "/settings/security",
      active: pathname.startsWith("/settings/security"),
      section: zhCN.settings.personal,
    },
    {
      id: "sessions",
      label: zhCN.settings.sessions,
      href: "/settings/sessions",
      active: pathname.startsWith("/settings/sessions"),
      section: zhCN.settings.personal,
    },
    {
      id: "notifications",
      label: zhCN.settings.notifications,
      href: "/settings/notifications",
      active: pathname.startsWith("/settings/notifications"),
      section: zhCN.settings.personal,
    },
    ...(isClientAdmin
      ? [
          {
            id: "organization",
            label: zhCN.settings.organization,
            href: "/settings/organization",
            active: pathname.startsWith("/settings/organization"),
            section: zhCN.settings.org,
          },
        ]
      : []),
  ];

  return (
    <SettingsLayout
      title={zhCN.settings.title}
      subtitle={zhCN.settings.description}
      navItems={navItems}
      onNavigate={(href) => router.push(href)}
    >
      {children}
    </SettingsLayout>
  );
}
